var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', {
    staticStyle: {
      "position": "relative"
    }
  }, [_vm.firstName ? _c('article', {
    staticClass: "loggedInUserBanner"
  }, [_c('h4', [_vm._v("Logged in as: " + _vm._s(_vm.firstName) + " " + _vm._s(_vm.lastName))]), _c('h4', [_vm._v("License: " + _vm._s(_vm.getLicenseName))])]) : _vm._e(), _c('div', {
    staticClass: "activity-id-label"
  }, [_vm.errorMessage ? _c('article', {
    staticClass: "errorAlert"
  }, [_c('button', {
    staticClass: "errorAlertXButton",
    on: {
      "click": function ($event) {
        _vm.errorMessage = '';
      }
    }
  }, [_vm._v("X")]), _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Error: ")]), _vm._v("\n      " + _vm._s(_vm.errorMessage) + "\n    ")]) : _vm._e(), _c('p', [_vm._v("Activity ID")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.activityId,
      expression: "activityId"
    }],
    staticClass: "activity-id",
    attrs: {
      "type": "text",
      "name": "activity-id"
    },
    domProps: {
      "value": _vm.activityId
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.activityId = $event.target.value;
      }
    }
  }), _c('button', {
    staticClass: "activity-id-go",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.launchByActivityId();
      }
    }
  }, [_vm._v("\n      GO\n    ")])]), _c('div', {
    staticClass: "activity-variants"
  }, [_c('h2', [_vm._v("Activity Variants")]), _c('ul', _vm._l(_vm.kwtActivities, function (item) {
    return _c('li', {
      key: item.variant,
      staticClass: "newJson",
      on: {
        "click": function ($event) {
          $event.preventDefault();
          return _vm.launchByActivityTypeVariant(item.variant);
        }
      }
    }, [_c('button', [_vm._v("\n          " + _vm._s(item.displayName) + "\n          "), _c('span', [_vm._v(_vm._s(item.variant))])])]);
  }), 0)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }